const videoSource10 = [
  {
    id: "video15",
    src: require("./1_13.mp4"),
  },
];

export default videoSource10;
